// Lightweight GA4 event tracker. No-ops until analytics is loaded (gated by
// production + cookie consent in src/routes/__root.tsx).
type GtagFn = (...args: unknown[]) => void;

function gtag(): GtagFn | null {
  if (typeof window === "undefined") return null;
  const w = window as unknown as { gtag?: GtagFn };
  return typeof w.gtag === "function" ? w.gtag : null;
}

export type AnalyticsEvent =
  | "page_view"
  | "sign_up"
  | "login"
  | "search"
  | "begin_checkout"
  | "purchase"
  | "add_to_watchlist"
  | "bid_submit"
  | "bid_confirm_open"
  | "bid_success"
  | "auction_view"
  | "auction_win"
  | "gallery_open"
  | "seller_listing_created"
  | "seller_listing_sold";

export function track(event: AnalyticsEvent, params: Record<string, unknown> = {}) {
  const g = gtag();
  if (!g) return;
  try {
    g("event", event, params);
  } catch {
    /* ignore */
  }
}

export function trackPageView(path: string, title?: string) {
  track("page_view", { page_path: path, page_title: title });
}
